/* ==========================================================================
   HUSHFERN — storefront JS
   Vanilla, no dependencies. Progressive enhancement only.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ *
   * Money
   * ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var fmt = (window.HF_THEME && window.HF_THEME.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec = parts[1];
    var out = fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole + '.' + dec)
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + dec);
    return out.replace(/<[^>]*>/g, '').trim();
  }

  /* ------------------------------------------------------------------ *
   * Toast
   * ------------------------------------------------------------------ */
  var toastTimer;
  function toast(msg) {
    var el = $('#hf-toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.hidden = true;
      el.classList.remove('is-on');
    }, 3200);
  }

  /* ------------------------------------------------------------------ *
   * Drawers (generic)
   * ------------------------------------------------------------------ */
  var lastFocus = null;

  function openDrawer(el, focusTarget) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var focusEl = focusTarget || $('[data-autofocus]', el);
    if (focusEl) setTimeout(function () { focusEl.focus(); }, 60);
    document.addEventListener('keydown', escClose);
  }

  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', escClose);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  function escClose(e) {
    if (e.key !== 'Escape') return;
    $$('.hf-drawer.is-open, .hf-cart-drawer.is-open').forEach(closeDrawer);
  }

  function initDrawerTriggers() {
    $$('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer($('#' + btn.getAttribute('data-drawer-open')));
      });
    });
    $$('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer(btn.closest('.hf-drawer, .hf-cart-drawer'));
      });
    });
    $$('.hf-drawer__scrim, .hf-cart-drawer__scrim').forEach(function (s) {
      s.addEventListener('click', function () { closeDrawer(s.parentElement); });
    });
  }

  /* ------------------------------------------------------------------ *
   * Cart
   * ------------------------------------------------------------------ */
  var cartState = null;

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        return data;
      });
    }).then(function () {
      return refreshCart();
    }).then(function () {
      if (opts.open !== false) openDrawer($('#hf-cart-drawer'));
      if (opts.message) toast(opts.message);
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) { renderCart(cart); return cart; });
  }

  function updateCountBadge(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    });
  }

  function guaranteeConfig() {
    var g = (window.HF_THEME && window.HF_THEME.guarantee) || {};
    return g.variantId ? g : null;
  }

  function renderCart(cart) {
    cartState = cart;

    var merchCount = cart.item_count;
    var merchTotal = cart.total_price;

    updateCountBadge(merchCount);

    var body  = $('[data-cart-body]');
    var foot  = $('[data-cart-foot]');
    var title = $('[data-cart-title]');
    if (title) title.textContent = 'Your bag (' + merchCount + ')';
    if (!body) return;

    if (merchCount <= 0) {
      // Nothing left in the bag.
      body.innerHTML =
        '<div class="hf-empty">' +
          '<p style="font-family:var(--hf-font-display);font-size:var(--hf-step-2);color:var(--hf-ink);margin-bottom:.5rem">Your bag is empty</p>' +
          '<p style="font-size:var(--hf-step--1)">Every Hushfern order ships free within Australia, with a 30-day money-back guarantee.</p>' +
          '<p style="margin-top:1.25rem"><a class="hf-btn" href="/products/quietclip-baby-hair-clipper">Shop QuietClip</a></p>' +
        '</div>';
      if (foot) { foot.hidden = true; foot.style.display = 'none'; }
      return;
    }
    if (foot) { foot.hidden = false; foot.style.display = ''; }

    var threshold = (window.HF_THEME && window.HF_THEME.freeShipThreshold) || 0;
    var shipTotal = merchTotal;
    var remaining = Math.max(0, threshold - shipTotal);
    var html = '';

    if (threshold > 0) {
      var pct = Math.min(100, Math.round((shipTotal / threshold) * 100));
      html += '<div class="hf-freeship" style="margin-bottom:1rem">';
      html += remaining > 0
        ? 'You\'re ' + formatMoney(remaining) + ' away from free express shipping'
        : 'You\'ve unlocked <b>free express shipping</b>';
      html += '<div class="hf-freeship__bar"><div class="hf-freeship__fill" style="width:' + pct + '%"></div></div></div>';
    }

    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy" width="76" height="76">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      html +=
        '<div class="hf-line-item" data-line-key="' + item.key + '">' +
          '<a class="hf-line-item__img" href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="hf-line-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
            (variant ? '<div class="hf-line-item__variant">' + variant + '</div>' : '') +
            (item.selling_plan_allocation ? '<div class="hf-line-item__variant">Monthly subscription · 20% off</div>' : '') +
            (function () {
              var out = '';
              var props = item.properties || {};
              Object.keys(props).forEach(function (k) {
                if (k.charAt(0) === '_') return;         // hidden properties
                var v = props[k];
                if (v === null || v === undefined || v === '') return;
                out += '<div class="hf-line-item__variant">' + k + ': ' + v + '</div>';
              });
              return out;
            })() +
            '<div class="hf-line-item__row">' +
              '<span class="hf-qty">' +
                '<button type="button" data-line-dec aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-line-inc aria-label="Increase quantity">&plus;</button>' +
              '</span>' +
              '<span style="font-weight:600">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="hf-link-u" data-line-remove ' +
              'style="background:none;border:0;border-bottom:1px solid var(--hf-sand-deep);padding:0;margin-top:.5rem;font-size:var(--hf-step--2);color:var(--hf-text-mute);cursor:pointer">Remove</button>' +
          '</div>' +
        '</div>';
    });

    // Assurance line follows the product in the bag
    var assurance = $('[data-cart-assurance]');
    if (assurance) {
      var wanted = assurance.getAttribute('data-assurance-product');
      var carries = (cart.items || []).some(function (it) {
        var m = (it.url || '').match(/\/products\/([^?]+)/);
        var h = it.handle || (m ? m[1] : '');
        return h === wanted;
      });
      var txt = $('[data-cart-assurance-text]', assurance);
      var want = carries ? assurance.getAttribute('data-assurance-sootheling')
                         : assurance.getAttribute('data-assurance-default');
      if (txt && want && txt.textContent.trim() !== want) txt.textContent = want;
    }


    body.innerHTML = html;

    var totalEl = $('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    var subEl = $('[data-cart-subtotal]');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
  }

  function initCartInteractions() {
    // Line item controls (delegated)
    document.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line-key]');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var item = cartState && cartState.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;

      if (e.target.closest('[data-line-inc]')) {
        changeLine(key, item.quantity + 1);
      } else if (e.target.closest('[data-line-dec]')) {
        changeLine(key, Math.max(0, item.quantity - 1));
      } else if (e.target.closest('[data-line-remove]')) {
        changeLine(key, 0);
      }
    });

    // Add to cart forms
    $$('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-atc-button]', form);
        var idInput = $('[data-variant-id]', form);
        var qtyInput = $('[data-qty-input]', form);
        if (!idInput || !idInput.value) { toast('Please choose an option first.'); return; }

        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding…'; }

        // Carry line item properties (the bundle's Band 2 / Band 3 colours)
        var props = {};
        $$('[name^="properties["]', form).forEach(function (inp) {
          if (inp.disabled) return;
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (!m) return;
          var v = (inp.value || '').trim();
          if (v) props[m[1]] = v;
        });
        var payload = { id: idInput.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 };
        if (Object.keys(props).length) payload.properties = props;
        var planInput = $('[name="selling_plan"]', form);
        if (planInput && !planInput.disabled && planInput.value) payload.selling_plan = planInput.value;
        var items = [payload];
        var refillToggle = $('[data-brookling-refill-add]', form);
        if (refillToggle && refillToggle.checked) {
          var colour = $('[data-option-input="0"]', form);
          var starterProps = Object.assign({}, props, {'Starter colour': colour ? colour.value : 'Jade', 'Deliveries': 'First: device + installed cartridge. Renewals: 1 cartridge only.'});
          items = [{id: refillToggle.getAttribute('data-refill-id'), quantity: payload.quantity, selling_plan: refillToggle.getAttribute('data-plan-id'), properties: starterProps}];
        }


        // Straight to checkout — the cart drawer is intentionally skipped.
        addToCart(items, { open: false }).then(function () {
          window.location.href = '/checkout';
        }).catch(function (err) {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
          toast(err.message || 'Sorry, something went wrong.');
        });
      });
    });

    // Quick add buttons
    $$('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.setAttribute('aria-disabled', 'true');
        addToCart([{ id: btn.getAttribute('data-quick-add'), quantity: 1 }], { open: false })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { btn.removeAttribute('aria-disabled'); toast(err.message || 'Sorry, something went wrong.'); });
      });
    });

    // Quantity steppers
    $$('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.hf-qty');
        var input = $('input', wrap);
        if (!input) return;
        var v = parseInt(input.value, 10) || 1;
        v += btn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
        input.value = Math.max(1, Math.min(99, v));
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Product variant picker
   *
   * Runs once per picker. Variant data may come from either:
   *   [data-product-json]  -> product page (option1/option2/option3)
   *   [data-variant-json]  -> featured product section (options array)
   * Option state always lives in the hidden [data-option-input] fields.
   * ------------------------------------------------------------------ */
  function parseVariants(scope) {
    var el = $('[data-product-json]', scope) || $('[data-variant-json]', scope);
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    var list = Array.isArray(data) ? data : (data.variants || []);
    return list.map(function (v) {
      var opts = (v.option1 !== undefined && v.option1 !== null) || v.option2 || v.option3
        ? [v.option1, v.option2, v.option3]
        : (v.options || []);
      return {
        id: v.id,
        title: v.title,
        available: v.available,
        price: v.price,
        price_money: v.price_money,
        compare_at_price: v.compare_at_price,
        options: opts,
        featured_image: v.featured_image || null
      };
    }).filter(function (v) { return v.id; });
  }

  function initBundleSwatches(picker, scope) {
    var box = $('[data-bundle-colours]', scope);
    if (!box || box.getAttribute('data-hf-bound') === '1') return;
    box.setAttribute('data-hf-bound', '1');

    $$('[data-bundle-option]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var band = btn.getAttribute('data-bundle-option');
        var val = btn.getAttribute('data-bundle-value');
        $$('[data-bundle-option="' + band + '"]', box).forEach(function (b) {
          var on = (b === btn);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var lbl = $('[data-bundle-label="' + band + '"]', box);
        if (lbl) lbl.textContent = val;
        var inp = $('[data-bundle-prop="' + band + '"]', box);
        if (inp) inp.value = val;
      });
    });
  }

  function initVariantPicker() {
    $$('[data-variant-picker]').forEach(function (picker) {
      if (picker.getAttribute('data-hf-bound') === '1') return;

      var form  = picker.closest('[data-product-form]') || picker.closest('form');
      var scope = picker.closest('.shopify-section') || form || document;
      var variants = parseVariants(scope);
      if (!variants || !variants.length) return;
      picker.setAttribute('data-hf-bound', '1');

      initBundleSwatches(picker, scope);

      var idInput     = $('[data-variant-id]', form || scope);
      var priceEl     = $('[data-price]', scope);
      var wasEl       = $('[data-compare]', scope);
      var saveEls     = $$('[data-save]', scope);
      var featPrice   = $('[data-price-now]', scope);
      var featWas     = $('[data-price-was]', scope);
      var featSave    = $('[data-price-save]', scope);
      var stickyPrice = $('[data-sticky-price]', scope);
      var atcBtn      = $('[data-atc-button]', form || scope);
      var stickyBtn   = $('[data-sticky-atc]', scope);
      var urgency     = $('.hf-urgency', scope);

      function norm(v) { return (v === null || v === undefined) ? '' : String(v).trim().toLowerCase(); }

      function selected() {
        var opts = [];
        $$('[data-option-input]', picker).forEach(function (input) {
          var idx = parseInt(input.getAttribute('data-option-input'), 10);
          opts[idx] = input.value;
        });
        if (!opts.length) {
          $$('.hf-swatch[aria-checked="true"]', picker).forEach(function (sw) {
            var idx = parseInt(sw.getAttribute('data-option-index'), 10);
            opts[idx] = sw.getAttribute('data-option-value');
          });
        }
        return opts;
      }

      function findVariant(opts) {
        var wanted = opts.map(norm);
        var exact = variants.filter(function (v) {
          return v.options.every(function (o, i) {
            return wanted[i] === '' || wanted[i] === undefined || o === null || norm(o) === wanted[i];
          });
        });
        return exact[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
      }

      function swapGalleryImage(src) {
        if (!src) return;
        var track = $('[data-gallery-track]', scope);
        var slides = $$('[data-gallery-slide]', scope);
        var thumbs = $$('[data-gallery-thumb]', scope);
        var idx = -1;
        slides.forEach(function (sl, i) {
          var im = $('img', sl);
          if (!im) return;
          if (im.getAttribute('src') === src || im.getAttribute('data-full') === src) idx = i;
        });
        if (idx > -1 && track && track.scrollTo) {
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        } else if (idx === -1 && slides.length) {
          // The variant shot is the hero rather than a slide of its own, so
          // swap it into the first slide and its thumbnail, then bring the
          // shopper back to it. This keeps the thumbnail strip short while
          // still showing the colour they picked.
          var firstImg = $('img', slides[0]);
          if (firstImg) {
            if (firstImg.getAttribute('src') !== src) {
              firstImg.removeAttribute('srcset');
              firstImg.setAttribute('src', src);
            }
            firstImg.setAttribute('data-full', src);
          }
          var firstThumbImg = thumbs[0] && $('img', thumbs[0]);
          if (firstThumbImg) {
            firstThumbImg.removeAttribute('srcset');
            firstThumbImg.setAttribute('src', src);
            firstThumbImg.setAttribute('data-full', src);
          }
          if (track && track.scrollTo) track.scrollTo({ left: 0, behavior: 'smooth' });
          idx = 0;
        }
        thumbs.forEach(function (t, i) {
          t.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }

      function sync(opts) {
        opts = opts || selected();          // resolve once so bundle logic can read it
        var variant = findVariant(opts);
        if (!variant) return;

        if (idInput) idInput.value = variant.id;

        var money = variant.price_money || formatMoney(variant.price);
        if (priceEl) priceEl.textContent = money;
        if (featPrice) featPrice.textContent = money;
        if (stickyPrice) stickyPrice.textContent = money;
        if (urgency) urgency.hidden = !variant.available;

        var compare = variant.compare_at_price;
        var hasCompare = compare && compare > variant.price;
        if (wasEl) {
          if (hasCompare) { wasEl.textContent = formatMoney(compare); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
        if (saveEls && saveEls.length) {
          saveEls.forEach(function (el) {
            if (hasCompare) {
              var saved = formatMoney(compare - variant.price).replace(/\.00(\s*)$/, '$1');
              el.textContent = 'Save ' + saved;
              el.hidden = false;
            } else {
              el.hidden = true;
            }
          });
        }

        // Bundle colour choices: only the 3-band bundle lets the shopper pick
        // three colours. Band 1 is the Colour option itself; 2 and 3 are extras.
        var bundleBox = $('[data-bundle-colours]', scope);
        var bIdx = parseInt(picker.getAttribute('data-bundle-index'), 10);
        if (bundleBox && bIdx > -1) {
          var bVal = (opts && opts[bIdx]) ? opts[bIdx] : '';
          var isBundle = /3\s*bands/i.test(bVal);
          bundleBox.hidden = !isBundle;
          $$('[data-bundle-prop]', bundleBox).forEach(function (inp) {
            inp.disabled = !isBundle;
          });
          $$('[data-opt-name]', picker).forEach(function (el) {
            if (!el.getAttribute('data-orig')) el.setAttribute('data-orig', el.textContent.trim());
            if (el.getAttribute('data-orig') === 'Colour') {
              el.textContent = isBundle ? 'Band 1' : 'Colour';
            }
          });
        }
        if (featWas) {
          if (hasCompare) { featWas.textContent = formatMoney(compare); featWas.hidden = false; }
          else { featWas.hidden = true; }
        }
        if (featSave) {
          if (hasCompare) {
            featSave.textContent = 'Save ' + formatMoney(compare - variant.price);
            featSave.hidden = false;
          } else { featSave.hidden = true; }
        }

        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
          atcBtn.textContent = variant.available ? 'Add to cart \u2014 ' + money : 'Sold out';
        }
        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        // Update URL without reload so shares keep the selection
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}

        return variant;
      }

      picker.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-option-value]');
        if (!sw || !picker.contains(sw)) return;
        e.preventDefault();
        var idx = sw.getAttribute('data-option-index');

        $$('[data-option-index="' + idx + '"]', picker).forEach(function (s) {
          s.setAttribute('aria-checked', 'false');
          s.classList.remove('is-active');
        });
        sw.setAttribute('aria-checked', 'true');
        sw.classList.add('is-active');

        var hidden = $('[data-option-input="' + idx + '"]', picker);
        if (hidden) hidden.value = sw.getAttribute('data-option-value');
        var lbl = $('[data-option-label="' + idx + '"]', picker);
        if (lbl) lbl.textContent = sw.getAttribute('data-option-value');

        var variant = sync();
        var img = sw.getAttribute('data-option-image') || (variant && variant.featured_image);
        swapGalleryImage(img);
      });

      // Initialise from the URL param, otherwise the first available variant
      var params = new URLSearchParams(window.location.search);
      var wanted = params.get('variant');
      var start = (wanted && variants.filter(function (v) { return String(v.id) === String(wanted); })[0])
        || variants.filter(function (v) { return v.available; })[0]
        || variants[0];

      if (start) {
        start.options.forEach(function (val, i) {
          if (val === null || val === undefined) return;
          var hidden = $('[data-option-input="' + i + '"]', picker);
          if (hidden) hidden.value = val;
          $$('[data-option-index="' + i + '"]', picker).forEach(function (s) {
            var on = norm(s.getAttribute('data-option-value')) === norm(val);
            s.setAttribute('aria-checked', String(on));
            s.classList.toggle('is-active', on);
          });
          var lbl = $('[data-option-label="' + i + '"]', picker);
          if (lbl) lbl.textContent = val;
        });

        var active = $('.hf-swatch.is-active[data-option-image]', picker);
        swapGalleryImage((active && active.getAttribute('data-option-image')) || start.featured_image);
        sync(start.options);
      }
    });
  }

  /* ------------------------------------------------------------------ *
   * Gallery
   * ------------------------------------------------------------------ */
  function initGallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    var track = $('[data-gallery-track]', main);
    if (!track) return;
    var thumbs = $$('[data-gallery-thumb]');
    var slides = $$('[data-gallery-slide]', track);
    if (!slides.length) return;

    function setActive(i) {
      thumbs.forEach(function (t, ti) {
        t.setAttribute('aria-current', ti === i ? 'true' : 'false');
      });
      var counter = $('[data-gallery-count]');
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var act = thumbs[i];
      if (act && act.scrollIntoView) {
        try {
          act.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        } catch (e) {}
      }
    }

    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      var left = i * track.clientWidth;
      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      setActive(i);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var idx = Math.round(track.scrollLeft / w);
        idx = Math.max(0, Math.min(idx, slides.length - 1));
        setActive(idx);
      });
    }, { passive: true });

    setActive(0);
  }

  /* ------------------------------------------------------------------ *
   * FAQ accordion
   * ------------------------------------------------------------------ */
  function initFaq() {
    $$('.hf-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hf-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Reveal on scroll
   * ------------------------------------------------------------------ */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // Arm the CSS only now that we know we can also disarm it, and add a
    // failsafe so nothing can ever stay invisible.
    document.documentElement.classList.add('hf-reveal');
    var showAll = function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    };
    window.setTimeout(showAll, 2500);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ *
   * Sticky header + sticky ATC
   * ------------------------------------------------------------------ */
  function initSticky() {
    var header = $('.hf-header');
    var atc = $('[data-sticky-atc-wrap]');
    var anchor = $('[data-atc-anchor]');

    var onScroll = function () {
      if (header) header.classList.toggle('is-stuck', window.scrollY > 8);
      if (!atc) return;
      // Mobile conversion: keep price + Add to cart permanently reachable
      // once the shopper starts moving, rather than waiting until they have
      // scrolled past the entire buy box.
      atc.classList.toggle('is-visible', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var stickyBtn = $('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = $('form[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * Newsletter -> customer form feedback
   * ------------------------------------------------------------------ */
  function initNewsletter() {
    $$('form[data-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = $('button', form);
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Signing up…'; }
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Everling parent-video carousel
   * Native horizontal scrolling makes this a true phone swipe rail. Mouse
   * pointer dragging is added for desktop without changing touch behaviour.
   * ------------------------------------------------------------------ */
  function initVideoCarousels() {
    $$('[data-video-carousel]').forEach(function (carousel) {
      if (carousel.dataset.videoCarouselReady === 'true') return;
      carousel.dataset.videoCarouselReady = 'true';

      var track = $('[data-video-track]', carousel);
      var slides = $$('[data-video-slide]', carousel);
      var dots = $$('[data-video-dot]', carousel);
      if (!track || !slides.length) return;

      // The property supplements Liquid's muted attribute for autoplay policies.
      $$('video', carousel).forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      });

      function activeIndex() {
        var closest = 0;
        var distance = Infinity;
        slides.forEach(function (slide, index) {
          var delta = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (delta < distance) { distance = delta; closest = index; }
        });
        return closest;
      }
      function updateDots() {
        var current = activeIndex();
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      }
      function goTo(index) {
        var target = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }

      $$('[data-video-prev]', carousel).forEach(function (button) {
        button.addEventListener('click', function () { goTo(activeIndex() - 1); });
      });
      $$('[data-video-next]', carousel).forEach(function (button) {
        button.addEventListener('click', function () { goTo(activeIndex() + 1); });
      });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });

      var pointer = null;
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', function (event) {
        if (!pointer || event.pointerId !== pointer.id) return;
        track.scrollLeft = pointer.left - (event.clientX - pointer.x);
      });
      function endDrag(event) {
        if (!pointer || event.pointerId !== pointer.id) return;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        pointer = null;
        track.classList.remove('is-dragging');
        updateDots();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      updateDots();
    });
  }

  /* ------------------------------------------------------------------ *
   * Boot
   * ------------------------------------------------------------------ */
  function boot() {
    initDrawerTriggers();
    initCartInteractions();
    initVariantPicker();
    initGallery();
    initFaq();
    initReveal();
    initSticky();
    initNewsletter();
    initVideoCarousels();

    refreshCart().catch(function () {
      updateCountBadge(0);
    });

    document.addEventListener('shopify:section:load', function () {
      initFaq(); initReveal(); initGallery(); initVariantPicker(); initVideoCarousels();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.Hushfern = { openDrawer: openDrawer, closeDrawer: closeDrawer, toast: toast, refreshCart: refreshCart };
})();


/* --- Announcement bar: repeat until it fills the viewport ------------------
   The Liquid renders the message set twice and the CSS shifts the track by
   exactly -50%, which is one full set. If one set is narrower than the screen
   the tail runs empty and you see a gap roll past. So widen each half to at
   least viewport + one set, using the SAME repeat count for both halves so the
   -50% loop stays seamless. */
(function () {
  var track = document.querySelector('.hf-announce__track');
  if (!track) return;
  var halves = Array.prototype.slice.call(track.querySelectorAll('.hf-announce__inner'));
  if (halves.length < 2) return;
  var originals = halves.map(function (half) {
    return Array.prototype.slice.call(half.children).map(function (child) { return child.cloneNode(true); });
  });
  var lastWidth = 0;
  function fill() {
    var width = document.documentElement.clientWidth;
    if (!width || width === lastWidth) return;
    halves.forEach(function (half, index) {
      half.replaceChildren.apply(half, originals[index].map(function (child) { return child.cloneNode(true); }));
    });
    var setWidth = halves[0].getBoundingClientRect().width;
    if (!setWidth) return;
    lastWidth = width;
    var repeats = Math.max(2, Math.ceil((width + setWidth) / setWidth));
    halves.forEach(function (half, index) {
      var fragment = document.createDocumentFragment();
      for (var i = 1; i < repeats; i++) {
        originals[index].forEach(function (child) {
          var clone = child.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          fragment.appendChild(clone);
        });
      }
      half.appendChild(fragment);
    });
  }
  fill();
  var timer;
  window.addEventListener('resize', function () {
    if (document.documentElement.clientWidth === lastWidth) return;
    clearTimeout(timer);
    timer = setTimeout(fill, 150);
  }, {passive: true});
})();

/* ---------------------------------------------------------------
   Hearthling two-hoodie pack: reveal the second hoodie pickers when
   the 2 Hoodies option is active, and keep the hidden line item
   properties in sync. Cleared when back on a single hoodie so a
   one-hoodie order never carries second-hoodie properties.
   --------------------------------------------------------------- */
(function () {
  function sync() {
    var box = document.querySelector('[data-hearthling-second]');
    if (!box) return;
    var on = false;
    var swatches = document.querySelectorAll('.hf-swatch.is-active');
    for (var i = 0; i < swatches.length; i++) {
      var v = (swatches[i].getAttribute('data-option-value') || swatches[i].innerText || '').trim();
      if (/^2\s*hoodies/i.test(v)) { on = true; break; }
    }
    box.hidden = !on;
    box.setAttribute('aria-hidden', on ? 'false' : 'true');
    var selects = box.querySelectorAll('[data-second-select]');
    for (var j = 0; j < selects.length; j++) {
      var key = selects[j].getAttribute('data-second-select');
      var inp = box.querySelector('[data-second-prop="' + key + '"]');
      if (inp) inp.value = on ? selects[j].value : '';
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.hf-swatch')) setTimeout(sync, 80);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-second-select]')) sync();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  setTimeout(sync, 500);
})();
